import { Blocks, Flex, Heading, Image, Container } from '@asktia/tia-ui'
import { FC } from 'react'
import { useAmpli, useScrollToTopOnPageLoad, useUserInfo } from 'src/hooks'
import TiaReceptionIllustration from '../../assets/tia-reception-illustration.png'
import { NewPatientActions } from 'src/pages/Landing/OnboardingRecommendedActions'

export const OnboardingRecommendedActions: FC = () => {
    const { user } = useUserInfo()
    useScrollToTopOnPageLoad()

    const {
        clickStartCareOnHomepage,
        clickHealthConcernOnHomepage,
        clickSomethingElseOnHomepage
    } = useAmpli()

    return (
        <Flex backgroundColor="secondaryBackground" sx={{ pb: 7 }}>
            <Container>
                <Flex sx={{ flexDirection: ['column', 'row'] }}>
                    <Flex
                        sx={{
                            pt: 6,
                            flexDirection: 'column'
                        }}
                    >
                        <Heading
                            h1
                            sx={{
                                textAlign: 'left',
                                width: '100%'
                            }}
                        >
                            Hi {user?.givenName}, what brings you in today?
                        </Heading>
                        <Image
                            src={TiaReceptionIllustration}
                            sx={{
                                width: '80%',
                                minWidth: 'initial'
                            }}
                        />
                    </Flex>

                    <Flex
                        sx={{
                            pt: 6,
                            flexDirection: 'column',
                            alignItems: 'left'
                        }}
                    >
                        <NewPatientActions
                            onClickedStartCare={clickStartCareOnHomepage}
                            onClickedHealthConcern={
                                clickHealthConcernOnHomepage
                            }
                            onClickedSomethingElse={
                                clickSomethingElseOnHomepage
                            }
                        />
                    </Flex>
                </Flex>
            </Container>
            <Blocks.Wave
                position="bottom"
                fill="mainBackground"
                sx={{ backgroundColor: 'secondaryBackground' }}
            />
        </Flex>
    )
}
